import React from 'react';

/**
 * "How Review Works" — the standing explainer beside every review screen.
 *
 * Extracted from EpisodeReview 18 Sep 2026 along with the other blocks on
 * that page. It holds no state and takes no props; it is here so the review
 * page stays small enough to edit safely.
 */
const STEPS = [{
  step: '01',
  title: 'Watch',
  body: 'The latest version plays here inside Portal.'
}, {
  step: '02',
  title: 'Respond',
  body: 'Add as many timecoded changes as you need.'
}, {
  step: '03',
  title: 'Approve',
  body: 'Confirm the version once you are happy.'
}, {
  step: '04',
  title: 'Download',
  body: 'Final deliverables move to Files after approval.'
}];
export function ReviewSidebar() {
  return <aside className="lg:col-span-4 lg:border-l lg:border-rule lg:pl-12" data-id="element-236" data-mp="339wwd4s06byx">
      <h2 className="label border-b border-rule pb-4 text-graphite" data-id="element-237" data-mp="2z7jzz6z5bqet">How Review Works</h2>
      <ol className="m-0 list-none p-0" data-id="element-238" data-mp="2z9d2ca2q7oh0">
        {STEPS.map(step => <li key={step.step} className="border-b border-rule py-6" data-id="element-239" data-mp="2u98rp0oi1nyp">
            <div className="flex items-baseline gap-4" data-id="element-240" data-mp="z9w5wqs7aplt">
              <span className="label text-mute" data-id="element-241" data-mp="141nmc8hn7ey8">{step.step}</span>
              <span className="font-display text-xl leading-none" data-id="element-242" data-mp="142yqwaiwwqqe">{step.title}</span>
            </div>
            <p className="mt-3 font-display text-base leading-snug text-graphite" data-id="element-243" data-mp="qc3qznqe5jyy">{step.body}</p>
          </li>)}
      </ol>
      <p className="label-sm mt-7 leading-relaxed text-mute" data-id="element-244" data-mp="1i1f7quahnxm9">
        Review copies stream from Google Drive · finals are delivered in Files
      </p>
    </aside>;
}